// Single source of truth for role values and role-driven routing metadata.
// Keep in sync with the `user_role` enum defined in supabase/migrations.

export const ROLES = Object.freeze({
  PARENT: "parent",
  TEACHER: "teacher",
  ADMIN: "admin",
  CMS_EDITOR: "cms_editor",
  PLATFORM_ADMIN: "platform_admin",
});

export const ROLE_LABELS = {
  [ROLES.PARENT]: "Parent",
  [ROLES.TEACHER]: "Teacher",
  [ROLES.ADMIN]: "Admin",
  [ROLES.CMS_EDITOR]: "CMS Editor",
  [ROLES.PLATFORM_ADMIN]: "Platform Admin",
};

// Which roles use the mobile-first shell vs. the desktop sidebar shell.
export const MOBILE_ROLES = [ROLES.PARENT, ROLES.TEACHER];
export const DESKTOP_ROLES = [ROLES.ADMIN, ROLES.CMS_EDITOR, ROLES.PLATFORM_ADMIN];

// Where each role lands after login.
export const ROLE_HOME = {
  [ROLES.PARENT]: "/parent",
  [ROLES.TEACHER]: "/teacher",
  [ROLES.ADMIN]: "/admin",
  [ROLES.CMS_EDITOR]: "/cms",
  [ROLES.PLATFORM_ADMIN]: "/platform",
};

export const isValidRole = (r) => Object.values(ROLES).includes(r);
